module.exports = __webpack_public_path__ + "img/charterscanners_logo.dc06ae4e.png";